import React, { useState } from "react";
import { BsPen, BsTrash } from "react-icons/bs";
import { useGlobalContext } from "context/globalContext";
import toast from "react-hot-toast";
import DeleteModal from "components/DeleteModal/DeleteModal";
import { deleteDestinationsAPI } from "Api/destinationsAPI";
import { consoleLog } from "helpers";

const EditAndDeleteDestination = (props) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const {
    setDestinationFormData,
    initialDestinationFormState,
    setFetchDestinations,
    setIsOpenDestinationEditForm,
  } = useGlobalContext();
  // const [isSubmitting, setIsSubmitting] = useState(false);
  const handleDeleteClick = () => {
    setIsModalOpen(true);
  };

  const handleDeleteConfirm = async () => {
    const token = localStorage.getItem("jwtToken");
    const response = await deleteDestinationsAPI(
      { id: props.cell.row.original.id },
      () => {},
      token
    );
    if (response) {
      toast.success(`Destination deleted successfully`);
      consoleLog(["Delete successful:", response.data]);
      setFetchDestinations(true);
    }
    if (!response) {
      toast.error("Destination deletion failed");
    }
    setIsModalOpen(false);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const handleFormOpen = () => {
    setDestinationFormData(
      props.cell?.row?.original
        ? {
            ...props.cell.row.original,
          }
        : {
            ...initialDestinationFormState,
          }
    );
    setIsOpenDestinationEditForm(true);
    consoleLog([props, "props"]);
  };

  return (
    <div className="flex gap-4">
      <BsPen
        className="cursor-pointer fill-amber-900 w-5 h-5"
        onClick={handleFormOpen}
      />
      <BsTrash
        className="cursor-pointer fill-amber-900 w-5 h-5"
        onClick={handleDeleteClick}
      />
      <DeleteModal
        isOpen={isModalOpen}
        onRequestClose={handleCloseModal}
        onDelete={handleDeleteConfirm}
      />
    </div>
  );
};

export default EditAndDeleteDestination;
